// src/services/api/brands.js
import { apiClient } from './base';

export const createBrand = async (brandData) => {
  try {
    const response = await apiClient.post('/product-brands', brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBrands = async (params = {}) => {
  try {
    const response = await apiClient.get('/product-brands', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBrand = async (brandId) => {
  try {
    const response = await apiClient.get(`/product-brands/${brandId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateBrand = async (brandId, brandData) => {
  try {
    const response = await apiClient.put(`/product-brands/${brandId}`, brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBrand = async (brandId) => {
  try {
    const response = await apiClient.delete(`/product-brands/${brandId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};